import { $iter } from "../iterator";
import { mapIndexed } from "./map-indexed";
export function indexed(...args) {
    const iter = $iter(indexed, args);
    if (iter) {
        return iter;
    }
    const from = args[0] || 0;
    return mapIndexed((i, x) => [from + i, x]);
}
